var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * ODListablePagination 은 ODListablePaginatedTable 에서 사용하기 위한 컴포넌트이다.
 * 향후 다양한 기능을 추가할 가능성이 있으며 디자인 등의 이유로 교체도 가능하므로 독자 컴포넌트로
 * 만들었다.
 */
import { range } from 'lodash';
import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import styled from 'styled-components';
import { useGlobalContext } from '../../global';
var CustomPaginationLink = styled(PaginationLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  :focus {\n    outline: none !important;\n    border: 1px solid ", " !important;\n    box-shadow: 0 0 4px ", " !important;\n  }\n"], ["\n  :focus {\n    outline: none !important;\n    border: 1px solid ", " !important;\n    box-shadow: 0 0 4px ", " !important;\n  }\n"])), function (p) { return p.box_color; }, function (p) { return p.box_shadow_color; });
export function ODListablePagination(props) {
    var listableContext = props.listableContext, _a = props.pageSpan, pageSpan = _a === void 0 ? 3 : _a, _b = props.hideIfSinglePage, hideIfSinglePage = _b === void 0 ? true : _b, wrapperStyle = props.wrapperStyle, itemActiveStyle = props.itemActiveStyle, itemDeactiveStyle = props.itemDeactiveStyle;
    var _c = React.useContext(listableContext), _d = _c.state, currentPage = _d.page, pageSize = _d.pageSize, totalCount = _d.totalCount, setPage = _c.setPage;
    var convertThemeString = useGlobalContext().convertThemeString;
    var primary = convertThemeString('{{primary}}');
    // add customization point if needed.
    var paginationActiveProps = {
        borderColor: primary,
        backgroundColor: primary,
        color: 'white',
    };
    var paginationNonActiveProps = {
        color: convertThemeString('{{primary}}'),
    };
    var linkProps = {
        box_color: primary,
        box_shadow_color: primary,
    };
    var maxPage = Math.ceil(totalCount / pageSize);
    maxPage = maxPage < 1 ? 1 : maxPage;
    var isDataMissingOrLoading = totalCount === -1 || currentPage < 1;
    if ((hideIfSinglePage && maxPage <= 1) || isDataMissingOrLoading) {
        return null;
    }
    if (currentPage > maxPage) {
        setPage(maxPage);
    }
    var paProps = itemActiveStyle || paginationActiveProps;
    var pdaProps = itemDeactiveStyle || paginationNonActiveProps;
    var paginationItems = range(currentPage - pageSpan, currentPage + pageSpan + 1)
        .filter(function (i) { return (i > 0 && i <= maxPage) || i === 1; })
        .map(function (page) {
        return (React.createElement(PaginationItem, { className: "od-pagination-item", key: page, active: page === currentPage, onClick: function () { return page !== currentPage && setPage(page); } },
            React.createElement(CustomPaginationLink, __assign({ tag: "button", style: page === currentPage ? paProps : pdaProps }, linkProps), page)));
    });
    var disabledStyle = {};
    var activeStyle = { color: convertThemeString('{{primary}}') };
    var prev = '<';
    var next = '>';
    var prevItems = (function () {
        var hasPrev = currentPage > 1;
        return (React.createElement(PaginationItem, { disabled: !hasPrev, onClick: function () { return hasPrev && setPage(currentPage - 1); } },
            React.createElement(CustomPaginationLink, __assign({}, linkProps, { previous: true, tag: "button", style: hasPrev ? activeStyle : disabledStyle }), prev)));
    })();
    var nextItems = (function () {
        var hasNext = currentPage < maxPage;
        return (React.createElement(PaginationItem, { disabled: !hasNext, onClick: function () { return hasNext && setPage(currentPage + 1); } },
            React.createElement(CustomPaginationLink, __assign({}, linkProps, { next: true, tag: "button", style: hasNext ? activeStyle : disabledStyle }), next)));
    })();
    return (React.createElement("div", { style: wrapperStyle },
        React.createElement(Pagination, null,
            prevItems,
            paginationItems,
            nextItems)));
}
var templateObject_1;
//# sourceMappingURL=ODListablePagination.js.map